// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"

import NestedRondoController from "./nested_rondo_controller"

application.register("nested-rondo", NestedRondoController)

import SelectController from "./select_controller"

application.register("select", SelectController)

import SelectedTabController from "./selected_tab_controller";

application.register("selected-tab", SelectedTabController);
